import { render, staticRenderFns } from "./text.vue?vue&type=template&id=95b41b36"
import script from "./text.vue?vue&type=script&lang=ts"
export * from "./text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports